import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ActionLink } from "@hopper-b2b/ui";
import styles from "./styles.module.scss";

interface FlightSearchButtonProps {
  showSearch: boolean;
  onClick: () => void;
}

export const FlightSearchButton: React.FC<FlightSearchButtonProps> = ({
  showSearch,
  onClick,
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "FlightSeachButton");

  return (
    <span className={block}>
      <ActionLink
        className={cn("edit-button")}
        content={
          <>
            <Icon
              iconName={showSearch ? IconNameEnum.close : IconNameEnum.edit}
            />
            <span className={cn("edit-text")}>
              {t(showSearch ? "hide" : "edit")}
            </span>
          </>
        }
        onClick={onClick}
      />
    </span>
  );
};
